module.exports = __webpack_public_path__ + "img/empty.386ce696.png";